import { StoreCode } from 'schema/storeCode';
import { AttributeInput, CartUpdateInput, CartUpdateLineItem } from '../types';
import { getShopifyCartById } from './cartById';
import { updateShopifyCartLines } from './cartLinesUpdate';

const METAFIELDS_TO_APPLY = [
  'flavor',
  'format',
  'servings',
  'pack_count',
  'product_version',
  'is_free_gift',
  'is_retention_gift',
  'is_sample',
  'is_merch',
  'is_marketing_insert',
  'is_accessory',
  'is_welcome_kit'
];

export const updateShopifyCartLineProperties = async (storeCode: StoreCode, cartId: string) => {
  // Fetch latest cart + metafield data
  const cart = await getShopifyCartById(storeCode, cartId);

  // Generate updated cart line payload with metafield data
  const updatedLines: CartUpdateLineItem[] = cart.lines.map((line) => {
    const existingAttributes = line.attributes || [];
    const metafieldsToApply = Object.entries(line.merchandise.metafields ?? {})
      .filter(([key]) => METAFIELDS_TO_APPLY.includes(key))
      .map(([key, value]) => ({ key: `__${key}`, value }) as AttributeInput);

    // Apply new metafields to existing attributes, overwrite if matching key
    const mergedAttributes = [...existingAttributes, ...metafieldsToApply].reduce((acc, curr) => {
      acc.set(curr.key, curr.value);
      return acc;
    }, new Map<string, string>());

    const updatedAttributes = Array.from(
      mergedAttributes,
      ([key, value]) => ({ key, value }) as AttributeInput
    );

    return {
      id: line.id,
      attributes: updatedAttributes
    };
  });

  const cartInput: CartUpdateInput = {
    cartId: cart.id,
    lines: updatedLines
  };

  await updateShopifyCartLines(storeCode, cartInput);
};
